import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

import SrDarkModal from 'client/components/SrDarkModal';

const SrBarcodeScanner = ({ onText, onClose }) => {
  const BarcodeScannerComponent = React.lazy(() => import('react-qr-barcode-scanner'));

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SrDarkModal onClose={onClose}>
        <BarcodeScannerComponent
          width="100%"
          height="100%"
          onUpdate={(err, result) => {
            if (result?.text) {
              onText(result.text);
            }
          }}
        />
      </SrDarkModal>
    </Suspense>
  );
};

SrBarcodeScanner.propTypes = {
  onText: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrBarcodeScanner.displayName = 'SrBarcodeScanner';

export default SrBarcodeScanner;
